import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as $ from 'jquery';
import { sortBy, last, groupBy, has, reduce, mapObject, template as _template } from 'underscore';
import { on, Options } from '../utils/decorators';
import moment from '../utils/moment';
import axios from 'axios';
import * as _ from 'underscore';

const today = moment();
const LightPick = require('lightpick');

@Options({
    template: false,
    ui: {
        calendarHeader: '[data-js-ui=calendar-holder-header]',
        calendarHeaderClose: '[data-js-ui=calendar-holder-header] .close',
        previousMonthButton: '[data-js-ui=previous-month-button]',
        nextMonthButton: '[data-js-ui=next-month-button]',
        monthTitle: '[data-js-ui=month-header]',
        dayList: '[data-js-ui=day-list]',
        eventItem: 'a.day-item__event',
        popoverContainer: '.popover-container',
        popoverCloseButton: '.popover-container .close-button',
    }
})
export default class CalendarView extends Marionette.View<Backbone.Model>{

    calendarToggleView?:Marionette.View<Backbone.Model>;
    constructor(options?:object) {
        super(options);
    }
    initialize() {
        //this.on('toggleCalendar', this.onToggleCalendar, this);
    }

    months = {}
    monthKeys = []
    performances = null
    scrolling = false
    currentMonth = null
    currentMonthIndex = 0
    headerOffsetHeight = 0
    headerOffsetTop = 0

    onRender() {

        this.loadPerformances().then((performances) => {
            this.$el.removeClass('loading');
            const lastEvent:any = last(performances);
            const lastDate = lastEvent.start_time_moment.clone().endOf('month').endOf('isoWeek');

            let firstDate = moment().startOf('week');

            this.performances = groupBy(performances, 'group');

            let index = 0;

            while (firstDate.isSame(lastDate, 'day') === false) {
                const day = firstDate.clone();

                const dayItem = this.dayItem(day, index++);

                this.ui.dayList.append(dayItem);

                firstDate.add(1, 'day');
            }

            const currentDay = $('.day-item--today');

            this.monthKeys = Object.keys(this.months);

            this.months = mapObject(this.months, (elem:any) => {
                return elem.get(0).getBoundingClientRect().top + window.scrollY;
            });

            this.updateTitle(currentDay);

            this.headerOffsetHeight = this.ui.calendarHeader.get(0).getBoundingClientRect().height;
            this.headerOffsetTop = this.ui.calendarHeader.get(0).getBoundingClientRect().y;

            this.scrollListener();

            this.flagTruncated();

            this.initializeCalendar(performances);

            // @ts-ignore
            $('.popover-container').on('click', this.onPopoverDismiss);
        });
    }
    @on('click @ui.calendarHeaderClose')
    oncalendarHeaderCloseClick(e: JQueryEventObject) {
        this.toggleCalendarVisibility(false);
    }


    addCalendarToggleView() {
        this.calendarToggleView = new CalendarToggleView()
        this.calendarToggleView.on('toggleVisibility', this.toggleCalendarVisibility, this)
        console.log(this);
    }

    toggleCalendarVisibility(show=true) {
        console.log(this.$el);
        const $calendarViewLightpick = this.$el.find('.calendar-holder__header .lightpick')[0];
        const $calendarView = this.$el.find('.calendar-holder__header')[0];
        (show) ? $calendarView.classList.add('visible') : $calendarView.classList.remove('visible');
        (show) ? $('body').addClass( "noScroll" ) : $('body').removeClass( "noScroll" );

    }

    initializeCalendar(perfs) {
        const calendarConfig = this.initialiseCalendarConfig(perfs);
        const config = {
            field: document.getElementById('datepicker'),
            lang: document.documentElement.lang,
            onSelect:  (start) => {
                this.toggleCalendarVisibility(false);
                const elements = document.querySelectorAll(`.day-item--${start.format('YYYY-MM-DD')}`);    // 2019-07-12

                // Adds and removes a class so that it triggers CSS effect to draw attention
                if (elements.length) {
                    elements.forEach(el => {
                        el.classList.add('calendar-focus');
                        setTimeout(() => {
                            el.classList.remove('calendar-focus');
                        }, 0);
                    });
                    // Focus on the first item
                    const firstEl = elements.item(0);
                    if (firstEl.scrollIntoView !== undefined) {
                        // firstEl.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
                        firstEl.scrollIntoView({block: 'center'});
                    } else {
                        console.error('scrollIntoView is undefined }:(');
                    }
                }
            }
        };
        this.addCalendarToggleView();
        setTimeout( () => {
            const lp = new LightPick({...config, ...calendarConfig});
            this.calendarToggleView.render();
        }, 1000);

    }

    initialiseCalendarConfig(performances) {
        const lastPerf:any = _.last(performances);
        const performanceDates = performances.map(perf => perf.perf_time_moment.format('YYYY-MM-DD'));
        const testDate = today.clone().startOf('day');
        const endDate = lastPerf.perf_time_moment.clone().startOf('day');

        const disabledDates = [];

        while (testDate <= endDate) {
            if (performanceDates.indexOf(testDate.format('YYYY-MM-DD')) === -1) {
                disabledDates.push(testDate.format('YYYY-MM-DD'));
            }

            testDate.add(1, 'day');
        }

        const minDate = today.clone();
        const maxDate = endDate.clone();

        let config = {
            locale: {
                buttons: {
                    prev: '<',
                    next: '>',
                },
            },
            inline: true,
            numberOfMonths: 1,
            numberOfColumns: 1,
            singleData: true,
            dropdowns: {
                years: false,
                months: false
            },
            minDate: minDate.format(),
            maxDate: maxDate.format(),
            disableDates: disabledDates,
        };

        return config;
    }

    loadPerformances() {
        return axios.get(`${(<any>window).DJANGO.apiEndpoint}/performances`).then((response) => {
            let performances = response.data.results.map((performance:any) => {
                const startTimeMoment = moment(performance.start_time);

                performance.start_time_moment = startTimeMoment;
                performance.group = startTimeMoment.format('YYYYMMDD');
                performance.perf_time_moment = moment(performance.perf_time);

                performance.truncated = performance.description;

                return performance;
            });

            performances = performances.filter((performance:any) => {
                return performance.start_time_moment.isSameOrAfter(today, 'hour');
            });

            sortBy(performances, (performance:any) => {
                return performance.start_time_moment.valueOf();
            });

            return performances;
        });
    }

    setTruncated(performance){
        let wordLength = 40;
        let truncated = performance.description.replace(/(<([^>]+)>)/ig,"");

        let wordArray = truncated.split(' ');

        if (wordArray.length > wordLength) {
            truncated = wordArray.slice(0, wordLength).join(' ');
            truncated = truncated + '…';
        }

        return truncated

    }

    dayPerformances(day) {
        const dayGroup = day.format('YYYYMMDD');

        if (dayGroup in this.performances) {
            return this.performances[dayGroup];
        }

        return [];
    }

    dayItem(day, index) {
        const dayPerformances = this.dayPerformances(day);
        const currentMonth = day.format('YYYYMM');

        const item = $('<div class="day-item"></div>');

        item.attr('title', day.format('dddd, Do MMMM, YYYY'));

        item.data({
            day: day.format('YYYY-MM-DD'),
            monthLabel: day.format('MMMM YYYY'),
            currentMonth: currentMonth,
            performances: dayPerformances,
        });

        item.attr({
            'data-current-month' : currentMonth
        });

        if (day.isSame(today, 'day')) {
            item.addClass('day-item--today');
        }

        if (day.isBefore(today, 'day')) {
            item.addClass('day-item--past');
        } else {
            item.addClass('day-item--' + day.format('YYYY-MM-DD'));

            if (has(this.months, currentMonth) === false) {
                this.months[currentMonth] = item;
            }
        }

        if (day.isAfter(today, 'day')) {
            item.addClass('day-item--future');
        }

        if (index % 7 > 4) {
            item.addClass('day-item--right');
        } else {
            item.addClass('day-item--left');
        }

        const dayTitle = this.dayTitle(day);
        const dayEvents = $('<div class="day-item__events"></div>');

        if (dayPerformances.length) {
            item.addClass('day-item--has-events');

            const performances = dayPerformances.map((performance) => {
                const name = this.parseHtml(performance.program.name);

                const time = $('<span class="day-item__event-time"></span>')
                .text(performance.start_time_moment.format('h:mmA'));

                const img = $(`<div class="day-item__image"><img src="${performance.image_1x1}"/></div>`);

                const title = $('<span class="day-item__event-title"></span>')
                .text(name);

                const performanceblock = $('<div class="day-item__performance-block"/>')
                .append(time, title);

                const perf = $('<a class="day-item__event"></a>')
                .attr('data-title', name)
                .attr('data-perf-id', performance.ticketing_system_id)
                .attr('data-date-id', day.format('YYYYMMDD'))
                .append(performanceblock, img);

                return perf;
            });

            dayEvents.append(performances);
        }

        item.append(dayTitle, dayEvents);

        return item;
    }

    dayTitle(day) {
        const title = $(`<h3 class="day-item__title"></h3>`);

        let mobileDate = day.format('ddd, MMM DD');
        title.append(`<span class="mobile">${mobileDate}</span>`);

        let mediumDate;

        if (day.date() === 1) {
            mediumDate = day.format('D MMM');
        } else {
            mediumDate = day.format('D');
        }

        title.append(`<span class="medium">${mediumDate}</span>`);


        // title.prepend(`<span class="medium">${day.format('D MMM')}</span>${day.format('D')}`);
        return title;
    }

    parseHtml(encodedString) {
        const div = document.createElement('div');
        div.innerHTML = encodedString;
        return div.textContent || div.innerText || '';
    }

    scrollListener() {
        window.addEventListener('scroll', () => {
            this.headerOffsetHeight = this.ui.calendarHeader.get(0).getBoundingClientRect().height;
            this.headerOffsetTop = this.ui.calendarHeader.get(0).getBoundingClientRect().y;

            if (this.scrolling) {
                return;
            }

            let visibleDay = null;

            $('.day-item:not(.day-item--past)').each((index, element) => {
                if (visibleDay === null && this.isInViewport(element)) {
                    visibleDay = $(element);
                }
            });
            this.updateTitle(visibleDay);
        });
    }

    flagTruncated() {
        $('.day-item__event').removeClass('day-item__event--is-truncated');
    }

    isInViewport(elem:any) {
        const bounding = elem.getBoundingClientRect();

        return (
            bounding.top >= (0 + this.headerOffsetHeight + this.headerOffsetTop) &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    updateTitle(day?:any) {
        day = day || $('[data-current-month="' + this.currentMonth + '"]');

        this.ui.monthTitle.text(day.data('monthLabel'));
        this.currentMonth = day.data('currentMonth');
        // update current index
        this.currentMonthIndex = reduce(this.monthKeys, (carry, month, index)=>{
            if (month === this.currentMonth){
                carry = index;
            }
            return carry;
        }, 0);

        this.determineButtons();
    }

    determineButtons() {
        this.ui.previousMonthButton.prop('disabled', true);
        this.ui.nextMonthButton.prop('disabled', true);

        let monthIndex = this.monthKeys.indexOf(this.currentMonth);

        if (this.monthKeys[this.currentMonthIndex - 1]) {
            this.ui.previousMonthButton.prop('disabled', false);
        }

        if (this.monthKeys[this.currentMonthIndex + 1]) {
            this.ui.nextMonthButton.prop('disabled', false);
        }
    }

    lerp (start, end, amt){
        return (1-amt)*start+amt*end
    }

    @on('click @ui.previousMonthButton')
    onPreviousMonthButtonClick(e: JQueryEventObject) {
        if (this.currentMonthIndex - 1 >= 0 ) {
            this.currentMonth = this.monthKeys[this.currentMonthIndex - 1];
            this.scrollToMonth(this.currentMonthIndex - 1);
        }
    }

    @on('click @ui.nextMonthButton')
    onNextMonthButton(e: JQueryEventObject) {
        if (this.currentMonthIndex + 1 <= this.monthKeys.length ) {
            this.currentMonth = this.monthKeys[this.currentMonthIndex + 1];
            this.scrollToMonth(this.currentMonthIndex + 1);
        }
    }

    scrollToMonth(index: Number) {
        if (this.scrolling) {
            return;
        }

        this.scrolling = true;

        const offset = this.ui.calendarHeader.get(0).getBoundingClientRect().height;
        const top = this.months[this.currentMonth];
        // Interval speed in the speed that the doc scrolls when the prev/next buttons are clicked
        // Don't go lower than this because the css animation that changes the height of the header on scroll
        // is slower and it will mess up the calculations for the position.
        const intervalSpeed = 80;
        let headerOffset, target = 0;
        let targetPos, docPos;

        /*
            Setting the values of the current header height, the position of the document and
            the current target position based on those changing values.
            We use different values and success states depending on whether we're
            going forward or back.
            If the index === 0 then were going to the first month
            so we set the target to 0 so we scroll to the top of the page.
        */
        let targetinterval = setInterval(() => {

            // going to the first month
            if (index === 0) {
                docPos = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
                target = Math.floor(this.lerp (
                    docPos,
                    0,
                    0.7
                ));
                window.scrollTo({
                    top: target,
                });

                if (docPos === 0) {
                    this.stopButtonScrolling(targetinterval);
                }
            }
            // going forward in time
            else if (index > this.currentMonthIndex) {
                targetPos = Math.floor(top - offset - this.headerOffsetTop);
                docPos = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
                target = Math.ceil(this.lerp (
                    docPos,
                    targetPos,
                    0.7
                ));
                window.scrollTo({
                    top: target,
                });

                if (docPos >= target  ) {
                    this.stopButtonScrolling(targetinterval);
                }
            }
            // going forward in time
            else if (index < this.currentMonthIndex) {
                targetPos = Math.ceil(top - offset - this.headerOffsetTop);
                docPos = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
                target = Math.floor(this.lerp (
                    docPos,
                    targetPos,
                    0.7
                ));
                window.scrollTo({
                    top: target,
                });

                if (docPos <= target  ) {
                    this.stopButtonScrolling(targetinterval);
                }
            }

        }, intervalSpeed);

    }

    stopButtonScrolling(targetinterval: any){
        clearInterval(targetinterval);
        this.scrolling = false;
        this.determineButtons();
        this.updateTitle();
    }

    @on('click @ui.eventItem')
    onItemClicked(e: JQueryEventObject) {
        const target = <HTMLElement> e.currentTarget;
        const perf = this.performances[target.dataset.dateId].find(perf => perf.ticketing_system_id === target.dataset.perfId);
        $('.popover-container').addClass('active');
        const results = new PerformanceItemPopup(perf);
        results && results.render();
    }

    @on('click @ui.popoverCloseButton')
    @on('click @ui.popoverContainer')
    onPopoverDismiss(e: JQueryEventObject) {

        let $element = $(e.target);

        console.log(e.target);
        if ($element.hasClass('calendar-modal') || $element.hasClass('close-button')) {
            e.preventDefault();
            e.stopPropagation();
            $('.popover-container').removeClass('active');
            $('.calendar-modal').html("");
        }
    }
}

const templateSettings: object = {
    evaluate: /<@([\s\S]+?)@>/g,
    interpolate: /<@=([\s\S]+?)@>/g,
    escape: /<@-([\s\S]+?)@>/g,
};

const PerformanceItemPopup = Marionette.View.extend({
    el: ".calendar-modal",

    render: function() {

        const template = _template(
            $('#calendar-item-popover').html(), templateSettings
        );

        this.$el.html( template(this.options) );
    }
});

const CalendarToggleView = Marionette.View.extend({
    el: "[data-js-ui=calendar-toggle-template]",
    ui: {
        toggleCalendar: 'a'
    },
    events: {
        'click @ui.toggleCalendar': 'onToggle'
    },

    onToggle(e) {
        e.preventDefault();
        this.trigger('toggleVisibility');
    },

    render() {
        const template = _.template(
            $('#calendar-toggle-template').html(), templateSettings
        );
        this.$el.html(template(this.options));
        console.log(this);
    }
});



// WEBPACK FOOTER //
// ./@modules/views/calendar-view.ts